export enum LogTypeEnum {
  TAKE_ACTION = 'take_action',
  COMMENT = 'comment',
  TAKE_ACTION_ON_FLOW = 'take_action_on_flow',
  ESCALATION = 'escalation',
  USER = 'user',
  COLLABORATOR = 'collaborator',
}
